import { Component, Inject, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';

export interface EditPriceDialogData {
  nomeProdotto: string;
  prezzo: number;
  unitaMisura?: string;
}

export interface EditPriceDialogResult {
  price: number;
}

@Component({
  selector: 'prd-edit-price-dialog',
  imports: [
    MatDialogModule,
    MatButtonModule,
  ],
  templateUrl: './edit-price-dialog.html',
  styleUrl: './edit-price-dialog.scss',
})
export class EditPriceDialog {
  protected price = signal(0);

  constructor(
    private dialogRef: MatDialogRef<EditPriceDialog, EditPriceDialogResult>,
    @Inject(MAT_DIALOG_DATA) readonly data: EditPriceDialogData,
  ) {
    this.price.set(data.prezzo);
  }

  onPriceInput(value: string) {
    const parsed = parseFloat(value);
    this.price.set(Number.isNaN(parsed) || parsed < 0 ? this.data.prezzo : parsed);
  }

  onClose() {
    this.dialogRef.close();
  }

  onConfirm() {
    this.dialogRef.close({ price: this.price() });
  }
}
